import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=28e00bbc&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "../components/style/main.scss?vue&type=style&index=0&id=28e00bbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e00bbc",
  null
  
)

export default component.exports